/**
 * Full Stack FastAPI MARIADB
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Payload para filtrar escenas por play_definition_ids.
 */
export interface VideoSceneFilterRequest { 
    play_definition_ids: Array<number>;
    attacking_team_id?: string | null;
    play_model_query?: string | null;
    twelve_seconds?: boolean;
}

